import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/tailwind.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from './i18n'

const app = createApp(App)

app.use(createPinia().use(piniaPluginPersistedstate))
app.use(i18n)

app.mount('#app')
